import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class BoxInventoryService {

    getBoxInventory(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BOX_INVENTORY
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putBoxInventory(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_BOX_INVENTORY
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new BoxInventoryService()